<template>
    <div>
        <PreviousGraph :chart-data="datacollection" :threshold="getYAxesMax" :height="100" />
    </div>
</template>

<script>
import PreviousGraph from '@/components/previous_data/PreviousGraph.vue';

export default {
    props: {
        selectCameraData: {
            type: Object,
            default: () => {},
            required: true
        },
        allCameraData: {
            type: Object,
            default: () => {},
            required: true
        },
        threshold: {
            type: Number,
            default: 0,
            required: true
        }
    },
    components: {
        PreviousGraph
    },
    computed: {
        getYAxesMax() {
            // グラフのy軸の最大値を10の位で切り上げ
            const digit = 10
            let num = Math.floor(this.threshold * 1.5)
            let max_num = Math.ceil(num / digit) * digit
            this.allCameraData.data_list.forEach(dailyData => {
                dailyData.forEach((barNum, index) => {
                    if (index !== 0 & index !== 1) {
                        if (barNum.max > max_num) {
                            max_num = Math.ceil(barNum.max / digit) * digit;
                        }
                    }
                })
                
            })
            return max_num
        },
        createdLineChart() {
            let line_data = []
            const thre_num = this.threshold
            this.$store.state.previousData.dataset.property.forEach(num => {
                line_data.push(thre_num)
                num;
            });
            return line_data
        },
        
        createdBarChart() {
            let bar_list = []
            const select = this.selectCameraData
            const preData = this.$store.state.previousData.dataset
            preData.property.forEach(dict => {
                
                let key = dict.prop
                bar_list.push(select[key])
            });
            return bar_list
        },
        
        datacollection() {
            return {
                labels: ['0','1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23'],
                datasets: [
                    {
                        label: '設定人数',
                        borderColor: '#f87979',
                        borderWidth:'2',
                        backgroundColor: 'rgba(0,0,0,0)',
                        data: this.createdLineChart,
                        type: 'line'
                    },
                    {
                        label: '最大人数',
                        backgroundColor: '#f8b979',
                        data: this.createdBarChart,
                        type: 'bar'
                    }
                ]
            }
        }
    }
}

</script>
